const testcaseType = {
    UPDATE_TCS: "UPDATE_TCS",
    UPDATE_TCS_COMMIT: "UPDATE_TCS_COMMIT",
    UPDATE_TCS_ROLLBACK: "UPDATE_TCS_ROLLBACK",

    RESET_TCS: "RESET_TCS"
  };
    
export default testcaseType;